import { Container, Stack, Typography } from "@mui/material";
import React from "react";
import { appImages } from "../../assets";
import Grid from "@mui/material/Grid";
import EcommerceCard from "../../components/cards/EcommerceCard";
import { t } from "i18next";

let renderData = [
  {
    image: appImages.catgoryCleaningImg,
    title: "Cleaning Products",
    description: "All best cleaning products for subscriptions as well",
    items: "100+",
    height: 400,
    id: "673ee5510a80d8b0a3c7946b",
  },
  {
    image: appImages.catgoryCarSkeletonImg,
    title: "Vehicle Parts ",
    description: "Just find out and then purchase it",
    items: "100+",
    height: 300,
    id: "673ee7b90a80d8b0a3c7947a",
  },
  {
    image: appImages.catgoryStationaryImg,
    title: "Stationary and Educational",
    description: "Just find out your subject and other stationary items",
    items: "100+",
    height: 300,
    id: "673ee9d20a80d8b0a3c794a1",
  },
  {
    image: appImages.catgoryMixProductImg,
    title: "All Other Items...",
    description: "You are on market place system just find out which you want",
    items: "100+",
    height: 400,
    id: "All",
  },
];

const Ecommerce = () => {
  return (
    <Container maxWidth={"lg"} sx={{ my: 4 }}>
      <Stack textAlign={"center"} mb={5}>
        {/* <Typography variant="body2" fontWeight={600} color={"text.redicalRed"}>
          CASE STUDIES
        </Typography> */}
        <Typography variant="heading_pr" component={"h1"}>
          {t("productEcom")}
        </Typography>
      </Stack>
      <Grid container rowSpacing={4} columnSpacing={4}>
        {/* <Grid item xs={12} sm={6}>
          <Grid container rowSpacing={3}>
            <Grid item xs={12}>
              <EcommerceCard data={renderData[0]} />
            </Grid>
            <Grid item xs={12}>
              <EcommerceCard data={renderData[2]} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Grid container rowSpacing={3}>
            <Grid item xs={12}>
              <EcommerceCard data={renderData[1]} />
            </Grid>
            <Grid item xs={12}>
              <EcommerceCard data={renderData[3]} />
            </Grid>
          </Grid>
        </Grid> */}
        {renderData?.map((x) => (
          <Grid item xs={12} sm={6} lg={3}>
            <EcommerceCard data={x} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Ecommerce;
